/**
 * View component for /user/login
 *
 * On render cycle this component checks to see if the redirectToReferrer boolean
 * is true (flipped on successful login).  If true, send the user back to the
 * referring page.  If false, show user login form.
 *
 * NOTE: upon reaching this page, user can toggle between /user/login and
 * /user/register without changing the original referring source route.
 */

// import primary libraries
import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { Link, Redirect, withRouter } from 'react-router-dom';
import { Helmet } from 'react-helmet';

// import actions actions
import * as userActions from '../userActions';
import * as userEventActions from '../../userEvent/userEventActions';

import routeUtils from '../../../global/utils/routeUtils';
import thirdPartyUtils from '../../../global/utils/thirdPartyUtils'; // in util so that we can make it database backed at some point in the future

// import form components
import AlertModal from '../../../global/components/modals/AlertModal.js.jsx';
import Base from "../../../global/components/BaseComponent.js.jsx";

// import user components
import UserLayout from '../components/UserLayout.js.jsx';
import UserLoginForm from '../components/UserLoginForm.js.jsx';
import { EmailInput, PasswordInput } from '../../../global/components/forms';

class LandingPageLogin extends Base {
  constructor(props) {
    super(props);
    this.state = {
      errorMessage: ''
      , isErrorModalOpen: false
      , redirectToReferrer: false
      , user: {
        username: ''
        , password: ''
      }
    }
    this._bind(
      '_handleFormChange'
      , '_handleFormSubmit'
      , '_toggleErrorModal'
      , '_goToResetPass'
    );
  }

  componentDidMount() {
    const { history, loggedInUser, location } = this.props;
    if(loggedInUser && loggedInUser._id) {
      // already logged in, forward to root
      history.push('/')
    }

    const searchObject = routeUtils.objectFromQueryString(location.search);
    console.log("MOUNT SEARCH OBJECT", searchObject)
    if(searchObject.redirect) {
      this.setState({
        relayStateString: JSON.stringify(searchObject)
      })
    }

  }

  componentWillReceiveProps(nextProps) {
    this.setState(nextProps);
    if(nextProps.status === "error") {
      alert(nextProps.error.message);
    }
  }

  _handleFormChange(e) {
    var nextState = this.state.user;
    nextState[e.target.name] = e.target.value;
    this.setState(nextState);
  }

  _handleFormSubmit(e) {
    e.preventDefault();
    const { dispatch, history } = this.props;
    dispatch(userActions.sendLogin(this.state.username, this.state.password)).then((action) => {
      if(action.success) {
        this.props.dispatch(userEventActions.sendCreateUserEvent({
          eventType: "user"
          , eventAction: "login"
        }));
        // this.setState({redirectToReferrer: true});
        // this.props.history.push('/my-agenda');
        
        // 1.22 - change this functionality to use query params. we need this to work with sso logins too.
        const searchObject = routeUtils.objectFromQueryString(location.search);
        history.push(searchObject.redirect || "/")

      } else {
        this.props.dispatch(userEventActions.sendCreateUserEvent({
          eventType: "user"
          , eventAction: "failed-login"
          , description: this.state.username
        }));
        this.setState({errorMessage: action.error});
        this._toggleErrorModal();
      }
    })
  }

  _toggleErrorModal() {
    this.setState({isErrorModalOpen: !this.state.isErrorModalOpen});
  }

  _goToResetPass() {
    const { history } = this.props;
    history.push('/user/forgot-password')
  }

  render() {
    const { from } = this.props.location.state || { from: { pathname: '/' } }
    const { redirectToReferrer, user, relayStateString } = this.state;
    const { match } = this.props;
    // console.log("THIRD PARTY SIGN IN!!!!!!!!", match.params.name);

    const thisLandingPageMeta = thirdPartyUtils.getLandingPageFromName(match.params.name);
    
    // console.log(thisLandingPageMeta);

    if(redirectToReferrer) {
      return (
        <Redirect to={from} />
      )
    } else {
      return  (
        <div className="master-layout">
          <Helmet
            title={thisLandingPageMeta.helmet}
          />
          <div className="body with-header -white">
            <div className="yt-container">
              <div className="yt-row with-gutters center-vert">
                <div className="yt-col full s_50 m_40">
                  { thisLandingPageMeta.thirdPartyLogoUrl ?
                    <img src={`${thisLandingPageMeta.thirdPartyLogoUrl}`}/>
                    :
                    null 
                  }
                  <h3>{thisLandingPageMeta.thirdPartyName}</h3>
                  <h1>{thisLandingPageMeta.portalName}</h1>
                  <br/>
                  <hr/>
                  <br/>
                  { thisLandingPageMeta.sponsorLogoUrl ?
                    <img src={`${thisLandingPageMeta.sponsorLogoUrl}`}/>
                    :
                    null 
                  }
                  { thisLandingPageMeta.sponsorName ?
                    <div>
                      <h3>Presented on behalf of</h3>
                      <h1>{thisLandingPageMeta.sponsorName}</h1>
                      <br/>
                      <hr/>
                    </div>
                    :
                    null 
                  }
                  <div className="-login-disclaimer -desktop-only">
                    <small>
                      <strong><em>PLEASE NOTE:</em></strong>
                      <p>You must use Chrome or Firefox in order to have the best experience. Internet Explorer is <strong><em>NOT</em></strong> supported.</p>
                      <p>Passwords are case sensitive.</p>
                      <p>Email <a href="mailto:prosupport@simulations-plus.com">prosupport@simulations-plus.com</a> with any questions.</p>
                      <p>By accessing this system I am confirming I am the person assigned this account. By using my unique login credentials I am attesting to my attendance to the assigned training programs</p>
                    </small>
                  </div>
                </div>
                <div className="yt-col full s_50 m_60">
                  <div className="form-container -skinny">
                    { thisLandingPageMeta.thirdPartyProvider ? 
                      <div className="yt-row center-horiz">
                        { relayStateString ? 
                          <a
                            href={`/api/users/saml-login/${thisLandingPageMeta.thirdPartyProvider}?RelayState=${relayStateString}`}
                            className="yt-btn primary"
                            style={{"margin":"20px"}}
                          >
                            {thisLandingPageMeta.thirdPartyLoginText ? 
                              thisLandingPageMeta.thirdPartyLoginText
                              :
                              `Login With ${match.params.name} SSO`
                            } 
                          </a>
                        :
                          <a
                            href={`/api/users/saml-login/${thisLandingPageMeta.thirdPartyProvider}`}
                            className="yt-btn primary"
                            style={{"margin":"20px"}}
                          >
                            {thisLandingPageMeta.thirdPartyLoginText ? 
                              thisLandingPageMeta.thirdPartyLoginText
                              :
                              `Login With ${match.params.name} SSO`
                            } 
                          </a>
                        }
                        <br/>
                        <hr/>
                        <div className="yt-row right">
                          <img src="/img/powered-by-logo.png"/>
                        </div>
                      </div>
                    :
                      <form name="userForm" className="user-form" onSubmit={this._handleFormSubmit}>
                        <h3> Sign In </h3>
                        <hr/>
                        <EmailInput
                          name="username"
                          label="Email Address"
                          value={user.username}
                          change={this._handleFormChange}
                          required={true}
                        />
                        <PasswordInput
                          name="password"
                          label="Password"
                          value={user.password}
                          change={this._handleFormChange}
                          required={true}
                          password={true}
                        />

                        <Link to="/user/forgot-password">
                          <em>
                            Forgot Password?
                          </em>
                        </Link>

                        <div className="input-group">
                          <div className="yt-row right">
                            <button className="yt-btn " type="submit" > Sign in </button>
                          </div>
                          {/* TODO: sso login link here?? */}
                        </div>
                      <hr/>
                      <div className="yt-row right">
                        <img src="/img/powered-by-logo.png"/>
                      </div>
                    </form>
                    }
                  </div>
                  <div className="-login-disclaimer -mobile-only">
                    <small>
                      <strong><em>PLEASE NOTE:</em></strong>
                      <p>You must use Chrome or Firefox in order to have the best experience. Internet Explorer is <strong><em>NOT</em></strong> supported.</p>
                      <p>Passwords are case sensitive.</p>
                      <p>Email <a href="mailto:prosupport@simulations-plus.com">prosupport@simulations-plus.com</a> with any questions.</p>
                      <p>By accessing this system I am confirming I am the person assigned this account. By using my unique login credentials I am attesting to my attendance to the assigned training programs</p>
                    </small>
                  </div>
                </div>
              </div>

              
              {/* <div className="yt-row center-horiz">
                <UserLoginForm
                  user={user}
                  handleFormSubmit={this._handleFormSubmit}
                  handleFormChange={this._handleFormChange}
                  location={this.props.location}
                />
              </div> */}
              <AlertModal
                alertMessage={this.state.errorMessage}
                alertTitle="Error with sign in"
                closeAction={this._toggleErrorModal}
                confirmAction={this._toggleErrorModal}
                confirmText="Try again"
                declineText="Reset Password"
                declineAction={this._goToResetPass}
                isOpen={this.state.isErrorModalOpen}
                type="danger"
              />
            </div>
          </div>
          <footer className="-third-party-footer -light">
            <div className="yt-container">

  
            </div>
          </footer>
        </div>
      )
    }
  }
}

LandingPageLogin.propTypes = {
  dispatch: PropTypes.func.isRequired
}

const mapStoreToProps = (store) => {
  return {
    loggedInUser: store.user.loggedIn.user
  }
}

export default withRouter(
  connect(
    mapStoreToProps
  )(LandingPageLogin)
);



// WEBPACK FOOTER //
// modules/user/views/LandingPageLogin.js.jsx